import { useEffect } from 'react';

import { Alert, CloseButton } from '@zillow/constellation-10';

import { emitViewImpreciseLocationAlertEvent, EVENT_IDS } from '../../analytics/events/correctMapPin';

import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';

const ImpreciseLocationAlert = ({
  confirmAddressButtonTitle,
  user,
  isOverlay = true,
}: {
  confirmAddressButtonTitle: string;
  user: Partial<RentalManagerAuthCheckUserInfoWebApiDto>;
  isOverlay?: boolean;
}) => {
  useEffect(() => {
    if (user) {
      emitViewImpreciseLocationAlertEvent({ user });
    }
  }, [user]);

  return (
    <Alert
      tone="warning"
      role="alert"
      closeButton={isOverlay ? <CloseButton /> : null}
      css={
        isOverlay
          ? {
              position: 'absolute',
              top: '100',
              zIndex: 2,
              margin: '0px {spacing.200}',
            }
          : undefined
      }
      data-testid="StaticMap-ImpreciseLocationAlert"
      data-eventid={EVENT_IDS.VIEW_IMPRECISE_LOCATION_ALERT}
      data-eventdescription="View alert event"
    >
      If the address is correct, select &quot;{confirmAddressButtonTitle}&quot;. You can adjust the property location
      while creating the listing.
    </Alert>
  );
};

export default ImpreciseLocationAlert;
